export default class ErrorHelper {
  static getErrorMessage(error): string {
    return error instanceof Error ? error.message : JSON.stringify(error);
  }
}
